module.exports = __webpack_public_path__ + "img/001.13f53d6b.png";